var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipPoultry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM7.48 18.01C7.57 18.06 7.65 18.12 7.72 18.19C7.89 18.36 7.99 18.59 7.99 18.83C7.99 19.07 7.89 19.29 7.72 19.46C7.38 19.81 6.8 19.81 6.44 19.46C6.17 19.19 6.1 18.78 6.26 18.43L6.4 18.15L5.84 17.59L5.55 17.73C5.2 17.89 4.79 17.82 4.52 17.55C4.17 17.2 4.17 16.63 4.52 16.27C4.87 15.92 5.44 15.92 5.8 16.27C5.87 16.34 5.94 16.42 5.98 16.51L6.25 17.09L8.36 14.98L9 15.62L6.89 17.73L7.47 18L7.48 18.01ZM18.28 12.76C17.56 13.48 16.1 14.06 13.97 14.46C12.98 14.65 12.09 15.12 11.37 15.83L11.24 15.95C11.07 16.13 10.78 16.13 10.61 15.95L10.28 15.63L8.05 13.4C7.96 13.31 7.91 13.2 7.91 13.07C7.91 12.95 7.96 12.83 8.05 12.75L8.17 12.62C8.88 11.91 9.35 11.01 9.54 10.02C9.94 7.89 10.52 6.44 11.24 5.71C12.18 4.77 13.43 4.25 14.76 4.25C16.09 4.25 17.34 4.77 18.28 5.71C20.22 7.65 20.22 10.8 18.28 12.75V12.76Z",
    fill: "#FE9A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipPoultry);
export default __webpack_public_path__ + "static/media/ic-chip-poultry.302d720c6f5450dde8e07ce0e7da51ab.svg";
export { ForwardRef as ReactComponent };